<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }} -->
    <!-- {{ item }} -->
    <b-card class="border-none py-0 mb-0 px-1">
      <!-- <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.description }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header> -->
      <b-card-body>
        <!-- <p class="text-center">{{ item.description }}</p> -->
        <form>
          <b-row class="mb-2">
            <b-col cols="12">
              <b-form-group label="Title:" label-for="title" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="item.description" size="sm" :disabled="readonly"
                    class="no-border large strong"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col cols="6" class="pr-2">
              <div class="c-avatar inline mt-1">
                <b-avatar v-if="user.avatarb64" :src="user.avatarb64"></b-avatar>
                <b-avatar v-if="!user.avatarb64" :text="user.initials"></b-avatar>
              </div>
              <b-form-group label="From:" label-for="from" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" v-model="item.from" disabled size="sm"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!--   <b-col cols="12">
              <b-form-group label="From:" label-for="from" label-cols="12">
                <b-input-group>
                  <b-form-input
                    type="text"
                    v-model="item.from"
                    disabled
                    size="sm"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col> -->
            <b-col cols="6">
              <b-form-group label="To:" label-for="to" label-cols="12">
                <treeselect instanceId="to" type="text" v-model="item.to" :clearable="true" :options="options_to"
                  :multiple="true" class="notifications" disabled="readonly"></treeselect>
              </b-form-group>
            </b-col>
            <b-col cols="3" v-if="item.id">
              <b-form-group label="Sent:" label-for="created_at" label-cols="12">
                <b-input-group>
                  <b-form-input type="text" :value="this.$helpers.datetimefield(item.created_at)" size="sm"
                    disabled></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row> </b-row>
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label-cols="12" label="Category" label-size="sm">
                <b-input-group>
                  <b-form-input v-model="item.category" :debounce="options.debounce" placeholder="Category" size="sm"
                    :disabled="readonly"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.category = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label-cols="12" label="Locator" label-size="sm">
                <b-input-group>
                  <b-form-input v-model="item.locator" :debounce="options.debounce" placeholder="Locator" size="sm"
                    :disabled="readonly"></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="readonly" @click="item.locator = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col cols="12">
              <wysiwyg v-model="item.data" :options="{
    hideModules: {
      code: true,
    },
  }" />
              <!-- hideModules: {
                      bold: true,
                      italic: true,
                      underline: true,
                      justifyLeft: true,
                      justifyCenter: true,
                      justifyRight: true,
                      headings: true,
                      link: true,
                      code: true,
                      orderedList: true,
                      unorderedList: true,
                      image: true,
                      table: true,
                      removeFormat: true,
                      separator: false,
                    }, -->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-row>
                <b-col>
                  <b-form-group label="Archive?" label-for="archive" label-cols="12">
                    <b-form-radio-group id="archive" v-model="item.archive" :options="[
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"
                      :disabled="false"></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="New?" label-for="new" label-cols="12">
                    <b-form-radio-group id="new" v-model="item.new" :options="[
    { text: 'Yes', value: true },
    { text: 'No', value: false },
  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline"
                      :disabled="false"></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Type" label-for="type" label-cols="12">
                <b-input-group>
                  <treeselect instanceId="type" type="number" v-model="item.type" :clearable="false"
                    :options="type_options" :disabled="false"></treeselect>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

        </form>
      </b-card-body>
      <b-card-footer class="p-0 pt-2 mt-2 mx-1">
        <b-row no-gutters>
          <b-col cols="auto" class="text-left">
            <b-button squared size="sm" class="mr-1" type="submit" variant="success"
              v-if="user.permissions.includes('notifications.save')" @click="saveit">
              <i :class="item.id ? 'fa fa-check mr-1' : 'fa fa-send mr-1'"></i>
              <span v-text="item.id ? 'Save It' : 'Send It'"></span>
            </b-button>
          </b-col>
          <b-col class="text-left ml-2 mt-1">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col cols="8" class="text-right">
            <b-button-group>
              <b-button squared size="sm" class="mr-1" type="submit" variant="secondary" @click="discard"><i
                  class="fa fa-chevron-left mr-1"></i>Back</b-button>

            </b-button-group>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "NotificationEdit",
  watch: {
    // search: {
    //   immediate: true,
    //   handler(newVal, oldVal) {
    //     this.message = null;
    //     if (newVal) {
    //       if (newVal.selected.addRow) {
    //         this.id = null;
    //         this.addRow();
    //       } else {
    //         this.id = newVal.selected.id;
    //         this.load();
    //       }
    //     }
    //     //this.loadDDL();
    //   },
    // },
  },
  data() {
    return {
      busy: false,
      requirement_notification: {
        // slac: "Client SL A/C",
      },
      message: "",
      id: null,
      options_to: [],
      type_options: [
        { id: "0", label: "Alert" },
        { id: "1", label: "OK" },
        { id: "2", label: "Message" },
      ],
      item: {
        from: null,
        to: [],
        description: "New Notification",
        data: null,
        type: null,
        category: null,
        new: true,
        archive: false,
        created_at: this.$moment().format("YYYY-MM-DD"),
        updated_at: this.$moment().format("YYYY-MM-DD"),
      },
      options: {
        title: "Notifications",
        icon: "fa fa-bell",
      },
    };
  },
  mounted() {
    this.item.from = this.user.email;
    this.loadDDL();
  },
  computed: {
    readonly() {
      return this.item.id ? true : false;
    },
  },
  methods: {
    async loadDDL() {
      try {
        const response = await this.$apollo.query({
          query: gql`
            query users_mssql {
              users_mssql(
                rolename: "admin,user"
                orderby: [["firstname", "asc"]]
              ) {
                id: email
                label
              }
            }
          `,
        });

        this.options_to = response.data.users_mssql;
      } catch (error) {
        console.log(error);
      }
    },
    async load() {
      this.busy = true;

      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query notifications($id: String, $dateformat: String) {
              notifications(id: $id, dateformat: $dateformat) {
                id
                archive
                new
                locator
                description
                type
                category
                data
                from
                to
                new
                archive
                created_at
                since
              }
            }
          `,
          variables,
        });
        console.log(response.data);
        if (response.data.notifications.length > 0) {
          this.item = response.data.notifications[0];

          this.item.to = this.item.to ? this.item.to.split(",") : [];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let requirement = { ...this.requirement_notification };

      console.log(requirement);

      let requirements = "";
      for (var prop in requirement) {
        if (this.item[prop] == null) {
          requirements += requirement[prop] + ", ";
          // break;
        }
      }
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        return;
      }

      let row = this.cleanit(this.item);
      row.to = row.to.length > 0 ? row.to.join(",") : null;

      this.busy = true;

      let variables = { rows: [row] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation notifications_save(
              $rows: [Notification_input]
              $dateformat: String
            ) {
              notifications_save(rows: $rows, dateformat: $dateformat) {
                id
                description
                type
                category
                data
                from
                to
                new
                archive
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },

    required(e) {

      this.requirement = {
        // slac: "Client SL A/C",
      };
    },
    discard() {
      this.$emit("discard");
    },
  },
};
</script>

<style></style>